export const numberFormat = (number) => {
    const numberFormatter = new Intl.NumberFormat(window.Citipo.locale);
    return numberFormatter.format(number);
};
export const dateFormat = (date) => {
    return new Date(date).toLocaleDateString(window.Citipo.locale);
};
export const datetimeFormat = (date) => {
    return new Date(date).toLocaleString(window.Citipo.locale);
};
export const countryName = (code) => {
    const displayNameFormatter = new Intl.DisplayNames(window.Citipo.locale, { type: 'region' });
    return displayNameFormatter.of(code);
};
